import { render, staticRenderFns } from "./AutoTopUpSettings.vue?vue&type=template&id=40b6c9f8&scoped=true"
import script from "./AutoTopUpSettings.vue?vue&type=script&lang=ts"
export * from "./AutoTopUpSettings.vue?vue&type=script&lang=ts"
import style0 from "./AutoTopUpSettings.vue?vue&type=style&index=0&id=40b6c9f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b6c9f8",
  null
  
)

export default component.exports